import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    // écoute globale pour ouvrir un panneau par ID
    this._onOpen = (e) => {
      const id = e.detail?.id
      if (!id) return
      this.openOnly(id)
    }
    window.addEventListener("more-panel:open", this._onOpen)
  }

  disconnect() {
    window.removeEventListener("more-panel:open", this._onOpen)
  }

  // Appelé par le bouton avec data-more-panel-id-param="..."
  dispatchOpen(event) {
    const id = event.params.id
    window.dispatchEvent(new CustomEvent("more-panel:open", { detail: { id } }))
  }

  // Ouvre uniquement le panneau correspondant et ferme les autres
  openOnly(id) {
    this.containerTargets.forEach((el) => {
      if (el.dataset.morePanelIdentifierValue === id) {
        this._openEl(el)
      } else {
        this._closeEl(el)
      }
    })
  }

  // Bouton "Fermer" à l’intérieur du panneau
  close(event) {
    // ferme le panneau le plus proche du bouton cliqué
    const panel = event?.target?.closest('[data-more-panel-target="container"]')
    if (panel) {
      this._closeEl(panel)
      return
    }
    // fallback : tout fermer
    this.containerTargets.forEach((el) => this._closeEl(el))
  }

  // Helpers
  _openEl(el) {
    if (!el) return
    el.classList.remove("translate-x-full")
    el.classList.add("translate-x-0")
    el.inert = false
    el.removeAttribute("aria-hidden")
  }

  _closeEl(el) {
    if (!el) return
    el.classList.remove("translate-x-0")
    el.classList.add("translate-x-full")
    el.inert = true
    el.setAttribute("aria-hidden", "true")
  }
}
